export default __webpack_public_path__ + "static/media/trophy.31d71f33.png";